import { createContext, useContext } from "react";

const PopoverContext = createContext<{
  _isInPopover: boolean;
}>({
  // True if component is rendered inside CustomPopover
  _isInPopover: false,
});

const inPopoverContextValue = {
  _isInPopover: true,
};

export const PopoverProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <PopoverContext.Provider value={inPopoverContextValue}>
      {children}
    </PopoverContext.Provider>
  );
};

/**
 * Checks if component is rendered inside a popover
 */
export const useIsInPopover = (): boolean => {
  const context = useContext(PopoverContext);
  return !!context?._isInPopover;
};
